import { useEffect, useState } from "react";

import { useForm, Controller } from "react-hook-form";
import { useLocation } from "react-router-dom";

import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Box,
  Button,
  Modal,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useGetElemDataById from "../../../hooks/useGetElemDataById";
import useGetUnlimitedListOf from "../../../hooks/useGetUnlimitedListOf";

const Update = ({ handleOpen, open, id }) => {
  const table = "Practice_Progresses"
  const axiosPrivate = useAxiosPrivate();
  const location = useLocation();

  const prev = useGetElemDataById(table, id,  "id");

  const [selectedpractice_code, setSelectedpractice_code] = useState();
  const [selectedpractice_state_id, setSelectedpractice_state_id] = useState();
  const practicesTemp = useGetUnlimitedListOf("Practices", "", "list");
  const practicesData = practicesTemp.listElements;

  const practice_statesTemp = useGetUnlimitedListOf("Practice_States", "", "list");
  const practice_statesData = practice_statesTemp.listElements;

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm();

useEffect(() => {
    if (prev) {
      if(prev.practice_code) {
        setSelectedpractice_code(prev.practice_code);
        setValue("practice_code", prev.practice_code);
      }
      if(prev.practice_state_id) {
        setSelectedpractice_state_id(prev.practice_state_id);
        setValue("practice_state_id", prev.practice_state_id);
      }
    }
  }, [prev]);

  const update = async (data) => {
if (!data.practice_code?.trim() || !data.practice_state_id?.trim()) {
    window.alert("practice_code, practice_state_id non possono essere vuoti!");
    return;
  }


    const nullColumns = Object.keys(data)
    .filter(key => data[key] === null || data[key] === "")
    .join("|");

    const deletedData = data;
    delete deletedData.id;
    try {
      const updatedData = {
				id: prev.id,
        new_values: deletedData,
        str_list_null: nullColumns,
      };

      console.log(updatedData);

      const response = await axiosPrivate.put(`/${table}/update`, updatedData);
      if (response) {
        window.alert("Modifica avvenuta con successo!");
        window.location.reload();
      }
    } catch (err) {
      if (err.response?.status === 401) {
        window.location.href = "/unauthorized";
      } else {
        window.location.href = "/login";
      }
    }
  };

  if (prev.length !== 0) {
    return (
      <>

        <Modal open={open}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              display: "flex",
              flexDirection: "column",
            }}
            alignItems={"center"}
          >
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              sx={{ mb: 2 }}
            >
              <Typography
                id="keep-mounted-modal-title"
                variant="h6"
                component="h2"
              >
                Aggiorna l'elemento con id {id} alla tabella {table}
              </Typography>
              <Button
                color="error"
                onClick={() => handleOpen(false, "mod")}
                sx={{
                  maxWidth: "30px",
                  maxHeight: "30px",
                  minWidth: "30px",
                  minHeight: "30px",
                }}
              >
                <CloseIcon />
              </Button>
            </Box>
            {/* Autocomplete per il campo practice_code */}
            <Autocomplete
              sx={{ width: "50%", m: 1 }}
              options={practicesData}
              getOptionLabel={(option) => option.code || ""}
              value={
                selectedpractice_code
                  ? practicesData.find((practice) => practice.code === selectedpractice_code)
                  : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  setSelectedpractice_code(newValue.code);
                  setValue("practice_code", newValue.code);
                } else {
                  setSelectedpractice_code(null);
                  setValue("practice_code", "");
              }}}
              isOptionEqualToValue={(option, value) =>
                option.code === value.code
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select practice_code"
                  placeholder="practice_code"
                  error={!!errors.practice_code}
                  helperText={
                    errors.practice_code ? "Il campo practice_code è obbligatorio" : ""
                  }
                  {...register("user_id")}
                />
              )}
            />
            {/* Autocomplete per il campo practice_state_id */}
            <Autocomplete
              sx={{ width: "50%", m: 1 }}
              options={practice_statesData}
              getOptionLabel={(option) => option.id || ""}
              value={
                selectedpractice_state_id
                  ? practice_statesData.find((practice) => practice.id === selectedpractice_state_id)
                  : null
              }
              onChange={(event, newValue) => {
                if (newValue) {
                  setSelectedpractice_state_id(newValue.id);
                  setValue("practice_state_id", newValue.id);
                } else {
                  setSelectedpractice_state_id(null);
                  setValue("practice_state_id", "");
              }}}
              isOptionEqualToValue={(option, value) =>
                option.id === value.id
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select practice_state_id"
                  placeholder="practice_state_id"
                  error={!!errors.practice_state_id}
                  helperText={
                    errors.practice_state_id ? "Il campo practice_state_id è obbligatorio" : ""
                  }
                  {...register("user_id")}
                />
              )}
            />
						{Object.entries(prev)
              .filter(([key]) => true && key !== "id" && key !== "practice_code" && key !== "practice_state_id")
              .map(([key, value], index) => (
                <TextField
                  key={index}
                  placeholder={key}
                  defaultValue={value}
                  sx={{ width: "50%", m: 1 }}
                  {...register(key)}
                />
              ))}
            <Button onClick={handleSubmit(update)}>SALVA MODIFICHE</Button>
          </Box>
        </Modal>
      </>
    );
  }
};

export default Update;